import { Component, OnInit, TemplateRef, ViewChild, ElementRef  } from '@angular/core';
import { Expediente, EvaluacionView } from 'app/models/expedientes/expediente';
import { Evaluacion } from 'app/models/evaluaciones/evaluacion';
import { ExpedienteService } from 'app/services/expediente.service';
import { EvaluacionService } from 'app/services/evaluacion.service';
import { ConvocatoriaService } from 'app/services/convocatoria.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AsignacionEvaluacionesComponent } from '../asignacion-evaluaciones/asignacion-evaluaciones.component';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';


@Component({
  selector: 'app-expediente',
  templateUrl: './expediente.component.html',
  styleUrls: ['./expediente.component.scss']
})

export class ExpedienteComponent implements OnInit {
  loading3: boolean;
  loading2: boolean;
  closeResult: string;
  expediente: Expediente;
  loading: boolean;
  modalRef: BsModalRef;
  idcentro: string;
  idconvocatoria: number;
  fecha_comision: string;
  rol: any;


  constructor(private modalService2: NgbModal,private route: ActivatedRoute,
              private router: Router,
              private expedienteService: ExpedienteService,
              private evaluacionService: EvaluacionService,
              private convocatoriaService: ConvocatoriaService,
              private modalService: BsModalService) {
  this.loading = true;

  }


  ngOnInit() {

    this.idcentro = String(this.route.snapshot.params['idcentro']);
    this.idconvocatoria = Number(this.route.snapshot.params['idconvocatoria']);
    if (this.idcentro && this.idconvocatoria ) { this.loadExpediente(this.idconvocatoria , this.idcentro); }
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.rol = currentUser.rol;
  }


  private loadExpediente(idconvocatoria, idcentro) {
    this.expedienteService.get(idconvocatoria, idcentro).subscribe(
      data => {this.expediente = data; this.loading = false; console.log(data)},
      error => {if (error.status = 401) {alert('Error de conexión con datos'); }}
    );
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-sm'});
  }


  updateEvaluacion(e, operacion): void {
    this.loading = true;
    this.evaluacionService.put(this.idconvocatoria, this.idcentro, e.IDTIPOEVALUACION, e.IDEVALUADOR, operacion,this.fecha_comision).subscribe(
      data => {this.loadExpediente(this.idconvocatoria , this.idcentro); },
      error => {if (error.status = 401) {alert('Error de conexión con datos'); }}
    );
    this.modalRef.hide();
  }


  decline(option): void {
    this.modalRef.hide();
  }


verEvaluacion2(e) {
  this.evaluacionService.getDOCEVALUACION(this.idconvocatoria, this.idcentro, e.IDTIPOEVALUACION, e.IDEVALUADOR, false)
  .subscribe( data => {
    const DOCEVALUACION = new Blob([atob(data)], {type: 'application/pdf'});
    const strURL = URL.createObjectURL(DOCEVALUACION);
    window.open(strURL);
    },
    error => {if (error.status = 401) {alert(error); }}
  );
}


loadingVer(id){
return false;
}




verEvaluacion(e) {
  

  if(this.expediente["TIPO"]==1){

  this.evaluacionService.getDOCEVALUACION(this.idconvocatoria, this.idcentro,  e.IDTIPOEVALUACION, e.IDEVALUADOR, false)
  .subscribe( data => {
    
    if([7,8,9,10,11].indexOf(e.IDTIPOEVALUACION) > -1 ){
    const DOCEVALUACION = new Blob([atob(data)], {type: 'application/pdf'});
    const strURL = URL.createObjectURL(DOCEVALUACION);
    window.open(strURL);
    this.loading2 = false;
    }
    else{
      const DOCEVALUACION = new Blob([data], {type: 'text/html'});
      const strURL = URL.createObjectURL(DOCEVALUACION);
      window.open(strURL);

    }

    },
    error => {if (error.status = 401) {alert('PROBLEMA DE CONEXIÓN. SI EL PROBLEMA PERSISTE PONGASE EN CONTACTO CON DEVA'); }}
  );

  }


  if(this.expediente["TIPO"]==2){
    this.evaluacionService.getDOCEVALUACION_SEG(this.idconvocatoria, this.idcentro,  e.IDTIPOEVALUACION, e.IDEVALUADOR)
    .subscribe( data => {
  
      var binaryImg = atob(data);
      var length = binaryImg.length;
      var ab = new ArrayBuffer(length);
      var ua = new Uint8Array(ab);
      for (var i = 0; i < length; i++) {
          ua[i] = binaryImg.charCodeAt(i);
      }
  
      const DOCAYUDA = new Blob([ua], {type: 'application/pdf'});
      const strURL = URL.createObjectURL(DOCAYUDA);
      window.open(strURL);
      },
      error => {if (error.status = 401) {alert(error); }}
    );
  }



}



vistaPrevia(idtipoevaluacion,idevaluador) {
  this.loading2 = true;
  this.evaluacionService.getDOCEVALUACION(this.idconvocatoria, this.idcentro, idtipoevaluacion, idevaluador, true)
  .subscribe( data => {
    if([7,8,9,10,11].indexOf(idtipoevaluacion) > -1){
      const DOCEVALUACION = new Blob([atob(data)], {type: 'application/pdf'});
      const strURL = URL.createObjectURL(DOCEVALUACION);
      window.open(strURL);
      this.loading2 = false;
    }
    else{
    const DOCEVALUACION = new Blob([data], {type: 'text/html'});
    const strURL = URL.createObjectURL(DOCEVALUACION);
    window.open(strURL);
    this.loading2 = false;      
    }
    },
    error => {if (error.status = 401) {alert(error); }}
  );

}


verResumen() {
  this.loading3 = true;
  this.expedienteService.getDOCRESUMEN(this.idconvocatoria, this.idcentro)
  .subscribe( data => {
    const DOCEVALUACION = new Blob([data], {type: 'text/html'});
    const strURL = URL.createObjectURL(DOCEVALUACION);
    window.open(strURL);
    this.loading3 = false;
    },
    error => {if (error.status = 401) {alert('PROBLEMA DE CONEXIÓN. SI EL PROBLEMA PERSISTE PONGASE EN CONTACTO CON DEVA'); }}
  );
}


verAyuda() {
  this.expedienteService.getDOCAYUDA(this.idconvocatoria, this.idcentro)
  .subscribe( data => {

    var binaryImg = atob(data);
    var length = binaryImg.length;
    var ab = new ArrayBuffer(length);
    var ua = new Uint8Array(ab);
    for (var i = 0; i < length; i++) {
        ua[i] = binaryImg.charCodeAt(i);
    }

    const DOCAYUDA = new Blob([ua], {type: 'application/pdf'});
    const strURL = URL.createObjectURL(DOCAYUDA);
    window.open(strURL);
    },
    error => {if (error.status = 401) {alert(error); }}
  );
}

verAlegaciones() {
  this.expedienteService.getDOCALEGACIONES(this.idconvocatoria, this.idcentro)
  .subscribe( data => {

    var binaryImg = atob(data);
    var length = binaryImg.length;
    var ab = new ArrayBuffer(length);
    var ua = new Uint8Array(ab);
    for (var i = 0; i < length; i++) {
        ua[i] = binaryImg.charCodeAt(i);
    }

    const DOCAYUDA = new Blob([ua], {type: 'application/pdf'});
    const strURL = URL.createObjectURL(DOCAYUDA);
    window.open(strURL);
    },
    error => {if (error.status = 401) {alert(error); }}
  );
}


verAutoinforme() {
  this.expedienteService.getDOCAUTOINFORME(this.idconvocatoria, this.idcentro)
  .subscribe( data => {

    var binaryImg = atob(data);
    var length = binaryImg.length;
    var ab = new ArrayBuffer(length);
    var ua = new Uint8Array(ab);
    for (var i = 0; i < length; i++) {
        ua[i] = binaryImg.charCodeAt(i);
    }

    const DOCAYUDA = new Blob([ua], {type: 'application/pdf'});
    const strURL = URL.createObjectURL(DOCAYUDA);
    window.open(strURL);
    },
    error => {if (error.status = 401) {alert(error); }}
  );
}





verAlanceTitulos() {
  this.expedienteService.getDOCTITULOS(this.idconvocatoria, this.idcentro)
  .subscribe( data => {

    var binaryImg = atob(data);
    var length = binaryImg.length;
    var ab = new ArrayBuffer(length);
    var ua = new Uint8Array(ab);
    for (var i = 0; i < length; i++) {
        ua[i] = binaryImg.charCodeAt(i);
    }

    const DOC = new Blob([ua], {type: 'application/pdf'});
    const strURL = URL.createObjectURL(DOC);
    window.open(strURL);
    },
    error => {if (error.status = 401) {alert(error); }}
  );
}






  verDocumentacion(idtipodocumentacion) {



    this.convocatoriaService.getDOCUMENTACION(this.idconvocatoria, idtipodocumentacion)
    .subscribe( data => {
  
      var binaryImg = atob(data);
      var length = binaryImg.length;
      var ab = new ArrayBuffer(length);
      var ua = new Uint8Array(ab);
      for (var i = 0; i < length; i++) {
          ua[i] = binaryImg.charCodeAt(i);
      }
      let tipoDocumentacion='';

      if (idtipodocumentacion==1){ tipoDocumentacion='application/pdf'; }
      if (idtipodocumentacion==2){ tipoDocumentacion='application/msword'; }
      if (idtipodocumentacion==3){ tipoDocumentacion='application/pdf'; }
      


      const DOCUMENTACION = new Blob([ua], {type: tipoDocumentacion});
      const strURL = URL.createObjectURL(DOCUMENTACION);
      
      if(idtipodocumentacion==2){
      var link = document.createElement('a');
      link.href = strURL;
      link.download="cuestionario.doc";
      link.click();
      }else{
        window.open(strURL);
      }
      // window.open(strURL);
      },
      error => {if (error.status = 401) {alert(error); }}
    );

  }



  delete(idtipoevaluacion,idevaluador) {
    this.loading = true;
    this.evaluacionService.delete(this.idconvocatoria,this.idcentro,idtipoevaluacion,idevaluador).subscribe(
      data => {
        this.loadExpediente(this.idconvocatoria, this.idcentro) ;
      },
      error => {
        if (error.status = 401) {alert('Error'); }
      }
    );
  
  }
  


  openModalWithComponent() {
    let options: NgbModalOptions = {
      size: 'lg',
    };
    const modalRef = this.modalService2.open(AsignacionEvaluacionesComponent,options);
    modalRef.componentInstance.idconvocatoria = this.idconvocatoria;
    modalRef.componentInstance.convocatoria = "5";
    modalRef.componentInstance.idcentro = this.idcentro;
    modalRef.result.then(() => { this.loadExpediente(this.idconvocatoria,this.idcentro); }, () => { console.log('Backdrop click')})

}



}



// WEBPACK FOOTER //
// /app/src/app/modules/expedientes/expediente/expediente.component.ts